import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Modal, message, Form } from 'antd'

import UploadQiniu from '../../commponents/uploadQiniu/index'
// const FormItem = Form.Item;
// const { TextArea } = Input;

class Qscode extends Component {

	constructor(props) {
		super(props)
		this.state = {
			name: '',
			departmentName: '',
			visible: false,
			token: '',
			url: '',
			modelTitel: '新增部门模板',
			subjectIcon: '',
			dataSource: [],
			qiuniuUrl: '',
			qrcodeId: null,
      isURL: true,
			searchData: {
				total: 0,
				pageNum: 1,
				pageSize: 10
			}
		}
	}
	handleOk=()=> {
    this.setState({ 
			visible: false
		 })
	}
	componentDidMount() {
		// this.getList()
		this.getToken()
	}
	showModal() {
		this.setState({ 
			visible: true,
			modelTitel: '图片上传',
			subjectIcon: ''
		 })
	}
	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url:  res.data.data.url,
				})
				// this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	render() {
		
		const { visible, modelTitel, subjectIcon,isURL } = this.state;
		const { getFieldDecorator } = this.props.form
		return (
			<div>
				<span style={{display: 'flex', alignItems: 'center',fontSize: '18px',fontWeight: '600'}}>图片链接生成</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between',marginBottom: '20px' }}>
					<Button className='my-button-primary' type='primary'  onClick={() => { this.showModal() }}>上传图片</Button>
				</div>
				<Modal
					getContainer={false}
					title={modelTitel}
					okText="确定"
					cancelText="取消"
					visible={visible}
					maskClosable={false}
					destroyOnClose
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<Form.Item label="图片">
							{getFieldDecorator('qscode', {
								initialValue: modelTitel==='图片上传'? subjectIcon: '',
								rules: [{ required: false, message: '请上传图片!' }],
							})(
									<UploadQiniu getQiniuUrl={this.getQiniuUrl} isURL={isURL} />
							)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		)
	}
}

export default Form.create()(Qscode)